import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../globals';

const UserInfoCard: VoidFunctionComponent = () => {
  const keysToShow = ['id', 'username', 'email', 'joined', 'organizationId', 'permission', 'createdAt'];
  return (
    <div className="panel">
      <h2 className="text-center">User Info</h2>
      <div className="flex-table">
        {/* eslint-disable-next-line you-dont-need-lodash-underscore/map */}
        {_.map(_.pick(window.user, keysToShow), (val, key) => (
          <div key={key} className="flex-table--row">
            <div className="flex-table--row--cell">
              <b>{key.toString()}</b>
            </div>
            <div className="flex-table--row--cell">{(val || '').toString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserInfoCard;
